/// <reference path='dapi.d.ts' />
import getFirstAncestor from './getFirstAncestor';
/**
 * Activates dapi download for this node and all child nodes.
 * That is a tags with target attribute 'dapi_download' will trigger a dapi download.
 * @param node
 * @param dapi
 * @returns {}
 */
export default function activateDAPIDownload(node, dapi) {
    node.addEventListener('click', (evt) => {
        const isDapiAnchor = (element) => (element.tagName === 'A' && element.attributes['target'] != null &&
            element.attributes['target'].value === 'dapi_download');
        const dapiAnchor = isDapiAnchor(evt.target) ? evt.target
            : getFirstAncestor(evt.target, (element) => {
                return isDapiAnchor(element);
            });
        if (dapiAnchor == null)
            return;
        evt.preventDefault();
        evt.stopPropagation();
        if (dapiAnchor.attributes['href'] == null)
            throw new Error("'href' attribute of anchor element must be set if target is 'dapi_download'");
        dapi.download(dapiAnchor.attributes['href'].value);
    }, true);
}
